import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
} from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class InscriptionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onMateriaPeriodoChanges: PropTypes.func.isRequired,
    onCarreraChanges: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    carreras: PropTypes.arrayOf(PropTypes.shape({})),
    subjects: PropTypes.arrayOf(PropTypes.shape({})),
    anho: PropTypes.number.isRequired,
  }

  static defaultProps = {
    submitting: false,
    carreras: [],
    subjects: [],
  }

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      anho,
      carreras,
      subjects = [],
      onMateriaPeriodoChanges,
      onCarreraChanges,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Container className="summary-container">
              <Row>
                <Col md={4} xl={6} sm={12}>
                  <div className="card__title">
                    <h5 className="bold-text">Materias del periodo</h5>
                  </div>
                </Col>
                <Col md={4} xl={6} sm={12}>
                  <div className="card__actions">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={submitting}
                      onClick={handleSubmit}
                    >Guardar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-outline-secondary"
                      onClick={onBack}
                    >Cancelar - Volver
                    </button>
                  </div>
                </Col>
              </Row>
            </Container>

            <Form className="form" onSubmit={handleSubmit}>

              <Container className="summary-container">
                <Row>
                  <Col md={6} xl={4} sm={12}>
                    <div className="form__form-group">
                      <span className="form__form-group-label required">Periodo</span>
                      <div className="form__form-group-field">
                        <input
                          value={`${anho}`}
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={6} xl={4} sm={12}>
                    <div className="form__form-group">
                      <span className="form__form-group-label required">Carrera</span>
                      <div className="form__form-group-field">
                        <Field
                          name="carrera"
                          component={renderSelectField}
                          placeholder="Carrera"
                          autoComplete="false"
                          options={carreras}
                          onChange={onCarreraChanges}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row dir="ltr">
                  {subjects.map(g => (
                    <Col md={6} xl={4} sm={12} key={`semester_${g.id}`}>
                      <Card>
                        <CardBody className="summary-card summary-card--primary">
                          <div className="summary-card__body checklist-card">
                            <h3 className="summary-card__title">{g.nombre}</h3>
                            <hr />
                            {g.materias.map(m => (
                              <div key={`subject_${m.materiaMallaId}`} className="summary-card__item">
                                <Field
                                  key={`subject_${m.materiaMallaId}`}
                                  name={`subject_${m.materiaMallaId}`}
                                  component={renderCheckBoxField}
                                  label={m.nombre}
                                  value={m.selected ? 'checked' : ''}
                                  defaultChecked={m.selected}
                                  onChange={v => onMateriaPeriodoChanges(m.materiaMallaId, v)}
                                />
                              </div>
                            ))}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>

            </Form>
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const InscriptionFormForm = reduxForm({
  form: 'InscriptionFormForm',
  validate,
  enableReinitialize: true,
})(InscriptionForm);

export default setPropsAsInitialValues(InscriptionFormForm);
